module.exports = __webpack_public_path__ + "static/media/body-parts-man.47a1a1e5.png";